// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JzUTr","content":"styles_content__xQZfN","tableWrap":"styles_tableWrap__3UOUW"};